export default __webpack_public_path__ + "89d0f751f65c63ee709b13089784ba2a.png";